import * as Sentry from '@sentry/react';

let initialized = false;

export function initObservability(): void {
  if (initialized) return;
  const dsn = (import.meta.env.VITE_SENTRY_DSN as string | undefined)?.trim();
  if (!dsn) return;
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_APP_VERSION as string | undefined,
    // We let users opt in to performance & replay tracing separately; default
    // is errors only to keep the bundle/cost minimal.
    tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? 0),
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    // Don't ship PII to Sentry by default. The admin user (id/email) is set
    // explicitly via setObservabilityUser() once login completes.
    sendDefaultPii: false,
  });
  initialized = true;
}

export function captureException(error: unknown, context?: Record<string, unknown>): void {
  if (initialized) {
    Sentry.captureException(error, context ? { extra: context } : undefined);
    return;
  }
  if (import.meta.env.DEV) {
    console.error('[captureException]', error, context);
  }
}

export function setObservabilityUser(user: { id: string; email: string } | null): void {
  if (!initialized) return;
  Sentry.setUser(user);
}

export function attachGlobalErrorHandlers(): void {
  window.addEventListener('unhandledrejection', (event) => {
    captureException(event.reason, { source: 'unhandledrejection' });
  });
  window.addEventListener('error', (event) => {
    captureException(event.error ?? event.message, { source: 'window.error' });
  });
}
